export default "__VITE_ASSET__DTput2lh__"